<ng-container *ngIf="deviation && deviation.deviationType as deviationType">
  <span
    *ngIf="showInTimeDeviation || deviationType === type.Delay || deviationType === type.Early"
    class="deviation"
    [ngClass]="
      deviationType === type.Delay ? 'delay-label' : deviationType === type.Early ? 'early-label' : 'complete-label'
    "
    [matTooltip]="tooltipValue"
    >{{ 'common.field.' + (deviationType | camelCase) | translate }}
  </span>
</ng-container>
